import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from '@firebase/firestore';
import { getStorage } from 'firebase/storage';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDXYyX0kDX6qHxwCj7qJXQzCbgBYeb_2sI",
  authDomain: "familyreunion-f83a2.firebaseapp.com",
  projectId: "familyreunion",
  storageBucket: "familyreunion.appspot.com",
  messagingSenderId: "770610495570",
  appId: "1:770610495570:web:8b4dd8746661df02dddf8b",
  measurementId: "G-YMVK6444QC"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
// export const storage = getStorage();
const analytics = getAnalytics(app);
export const firestore = getFirestore(app);